export default __webpack_public_path__ + "static/media/txt3.a45a375d.jpg";